// 根据不同的权限返回跳转路劲
export function checkReturnUrl (userInfo) {
  let loginKeys = {
    url: '',
    privateKey: ''
  }

  if (userInfo.companyId === 0 || userInfo.companyId === -1) { // 无所属公司
    loginKeys.privateKey = 'admin'
    loginKeys.url = process.env.admin_address
  } else {
    loginKeys.privateKey = 'workbench'
    loginKeys.url = process.env.workbench_address
  }
  return loginKeys
}
